import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'ng2-file-upload';

import { CapitalisationComponent } from './capitalisation.component';
import { CapitalisationService } from './capitalisation.service';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    FileUploadModule
  ],
  declarations: [
    CapitalisationComponent
  ],
  providers: [
    CapitalisationService
  ],
})
export class CapitalisationModule { }
